import { Box, Tooltip, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useMemo } from 'react';
import { formatDate } from '@/shared/lib';
import { Switch } from '@/shared/ui';
import { LINE_COLORS } from '../LineChart/constants';
import type { ListProps } from './types';

const List = styled('ul')(({ theme }) => ({
  margin: 0,
  padding: theme.spacing(2),
  listStyleType: 'none',
  overflow: 'auto',
  position: 'absolute',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));
const Item = styled('li')(({ theme }) => ({
  padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
  backgroundColor: 'white',
  border: '1px solid #BBBEC8',
  borderRadius: theme.shape.borderRadius,
  lineHeight: 1.5,
  fontSize: '0.75rem',
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

export function SplitLegendList({
  isDateContent,
  filterQuery,
  options,
  onOptionToggle,
  inactiveOptionsSet,
}: ListProps) {
  const preparedOptions = useMemo(() => {
    const preparedQuery = filterQuery.toLowerCase();

    return options.filter((option) => {
      return option.toLowerCase().includes(preparedQuery);
    });
  }, [options, filterQuery]);

  if (preparedOptions.length === 0) {
    return (
      <Typography
        color="text.secondary"
        variant="body2"
        sx={{ my: 2, textAlign: 'center' }}
      >
        Nothing found.
      </Typography>
    );
  }

  const handleOptionToggle = (option: string) => () => {
    onOptionToggle(option);
  };

  return (
    <List>
      {preparedOptions.map((option, index) => {
        let name = option;

        if (isDateContent) {
          name = formatDate(name);
        }

        return (
          <Item key={option}>
            <Switch
              customColor={LINE_COLORS[index % LINE_COLORS.length]}
              checked={!inactiveOptionsSet.has(option)}
              onChange={handleOptionToggle(option)}
            />
            <Tooltip title={name}>
              <Box
                component="span"
                sx={{
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
              >
                {name}
              </Box>
            </Tooltip>
          </Item>
        );
      })}
    </List>
  );
}
